import { Injectable } from '@angular/core'
import { CreateTemplateDrawerComponent } from './create-template-drawer.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { SignatureTemplateType } from '@tv3/containers/inquiries/overlays/inquiry-overlay/automata-booking-overlay/store/signature-template'

@Injectable({
  providedIn: 'root',
})
export class CreateTemplateDrawerService {
  constructor(private dialog: DialogService) {}

  public open(type?: SignatureTemplateType) {
    return this.dialog.openDrawer(CreateTemplateDrawerComponent, {
      panelClass: ['drawer-full-80'],
      data: { type },
    })
  }
}
